import { render, staticRenderFns } from "./Jobsharing.vue?vue&type=template&id=36440d7c&"
import script from "./Jobsharing.vue?vue&type=script&lang=js&"
export * from "./Jobsharing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports